export const campaignVersionSubRoute = {
  requestReport: "requestreport",
} as const;

export type CampaignVersionRoutes = {
  sub: typeof campaignVersionSubRoute.requestReport;
  method?: "Post";
};
